'use client';

import { __awaiter, __generator, __assign } from '../../_virtual/_tslib.js';
import React__default, { useRef, useImperativeHandle } from 'react';
import Input from '../../Input/index.js';
import Col from '../../LayoutSystem/Col.js';
import Row from '../../LayoutSystem/Row.js';
import { Contact, Working, Required } from '../index.css.js';
import { useResumeModal } from '../context/useResumeModal.js';
import I11lPhoneNumberInput from '../../I11lPhoneNumberInput/index.js';
import MultipleRadio from '../../MultipleRadio/index.js';
import SingleRadio from '../../SingleRadio/index.js';
import { rules } from '../utils/index.js';
import { META_API_LINK, VIETNAM_COUNTRY_ID, INTERNATIONAL_CITY_ID, notAllowCityId } from '../constants.js';
import DatePicker from '../../DatePicker/components/DatePicker.js';
import '../../Calendar/index.js';
import '../../DatePicker/styles.css.js';
import { EDatePicker } from '../../DatePicker/type.js';
import '../../Calendar/types.js';
import { ELanguage } from '../../Utils/constants.js';
import '../../DateInput.tsx/index.js';
import 'react-dom';
import '../../hooks/useMakeSearchable/types.js';
import { isMobile } from '../../Utils/helpers.js';
import '../../services/resumes/types.js';
import { updateUserContactInfo } from '../apiServices.js';
import Form from '../../Form/index.js';
import { EMaritalStatus } from '../type.js';

var ContactInfo = function (_a, ref) {
    var formData = _a.formData, baseApiUrl = _a.baseApiUrl, nationalityOptions = _a.nationalityOptions, countryOptions = _a.countryOptions, cityOptions = _a.cityOptions, districtOptions = _a.districtOptions, accessToken = _a.accessToken, apiGetUserContactInfo = _a.apiGetUserContactInfo, setContactInfo = _a.setContactInfo, checkDoneStep = _a.checkDoneStep;
    var _b = useResumeModal(), t = _b.t, lang = _b.lang, setStep = _b.setStep, setShowLoading = _b.setShowLoading;
    var isMobileScreenSize = isMobile();
    var formRef = useRef(null);
    var i11lPhoneNumberRef = useRef(null);
    var onSubmit = function () {
        if (formRef.current) {
            // formRef.current.requestSubmit()
            formRef.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
    };
    useImperativeHandle(ref, function () {
        return {
            onSubmit: onSubmit
        };
    }, []);
    var handleUpdateContactInfo = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var body, update, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = __assign(__assign({}, data), { cityId: data.countryId !== VIETNAM_COUNTRY_ID ? INTERNATIONAL_CITY_ID : data.cityId, districtId: data.cityId === INTERNATIONAL_CITY_ID || data.countryId !== VIETNAM_COUNTRY_ID ? 0 : data.districtId });
                    /*
                     * Set contact info back to global data
                     * */
                    setContactInfo(body);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    setShowLoading(true);
                    return [4 /*yield*/, updateUserContactInfo({
                            accessToken: accessToken || '',
                            url: "".concat(baseApiUrl).concat(apiGetUserContactInfo),
                            data: body
                        })];
                case 2:
                    update = _a.sent();
                    setShowLoading(false);
                    if (update.data) {
                        setStep(3);
                        checkDoneStep && checkDoneStep(2);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('save form contact info: ', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getLocalizedOptions = function (data) {
        if (data === void 0) { data = []; }
        return (data || []).map(function (_a) {
            var id = _a.id, name = _a.name, nameEn = _a.nameEn;
            return ({
                id: id,
                name: lang === ELanguage.EN ? nameEn : name
            });
        });
    };
    var today = new Date();
    var year = today.getFullYear();
    var month = today.getMonth();
    var date = today.getDate();
    var maxDate = new Date(year, month, date, 23, 59, 59);
    return (React__default.createElement(Contact.Section, null,
        React__default.createElement(Contact.SectionWrapper, { isMobile: isMobileScreenSize },
            React__default.createElement(Working.Title, null, t('Thông tin được tự động điền cho bạn nếu có thể.')),
            React__default.createElement(Form, { key: "key-".concat(JSON.stringify(formData)), ref: formRef, initialValues: formData, requestScrollToFirstErrorElement: true, onSubmit: function (values) { return handleUpdateContactInfo(values); } },
                React__default.createElement("button", { hidden: true, type: 'submit' }, "button"),
                React__default.createElement(Contact.Form, null,
                    React__default.createElement(Row, { gutter: [24, 16] },
                        React__default.createElement(Form.Item, { name: 'email', rules: rules({ types: ['required'], t: t }) }, function (field) {
                            return (React__default.createElement(Col, { xs: 24, md: 12 },
                                React__default.createElement(Form.Label, null, t('Email')),
                                React__default.createElement(Input, { type: 'text', value: field.value, onChange: field.onChange, onBlur: field.onBlur, hasError: field.isError, disabled: true }),
                                React__default.createElement(Form.Error, null)));
                        }),
                        React__default.createElement(Form.Item, { name: 'phone', rules: rules({
                                types: ['required', 'international-phone-number', 'vn-phone-number'],
                                t: t
                            }) }, function (field) {
                            return (React__default.createElement(Col, { xs: 24, md: 12 },
                                React__default.createElement(Form.Label, null,
                                    " ",
                                    t('Điện thoại')),
                                React__default.createElement(I11lPhoneNumberInput, { value: field.value, hasError: field.isError, onChange: field.onChange, onBlur: field.onBlur, urlMeta: "".concat(baseApiUrl).concat(META_API_LINK), language: lang, ref: i11lPhoneNumberRef, floatingConfig: {
                                        position: 'fixed',
                                        enablePortal: true,
                                        useWindowAsFlippingContainer: true
                                    } }),
                                React__default.createElement(Form.Error, null)));
                        })),
                    React__default.createElement(Row, { gutter: [24, 16] },
                        React__default.createElement(Form.Item, { name: 'birthday', rules: rules({ types: ['required'], t: t }) }, function (field) {
                            return (React__default.createElement(Col, { xs: 24, md: 12 },
                                React__default.createElement(Form.Label, null,
                                    " ",
                                    t('Ngày sinh')),
                                React__default.createElement(DatePicker, { type: EDatePicker.date, langCode: lang, defaultDate: field.value, onChange: function (value) {
                                        field.onChange(value);
                                    }, hasError: field.isError, onBlur: function () {
                                        field.onBlur();
                                    }, max: maxDate, calendarConfig: {
                                        floatingConfig: {
                                            position: 'fixed',
                                            enablePortal: true,
                                            useWindowAsFlippingContainer: true
                                        }
                                    } }),
                                React__default.createElement(Form.Error, null)));
                        }),
                        React__default.createElement(Form.Item, { name: 'nationalityId', rules: rules({ types: ['required'], t: t }) }, function (field) {
                            return (React__default.createElement(Col, { xs: 24, md: 12 },
                                React__default.createElement(Form.Label, null,
                                    " ",
                                    t('Quốc tịch')),
                                React__default.createElement(MultipleRadio, { options: nationalityOptions !== null && nationalityOptions !== void 0 ? nationalityOptions : [], name: 'nationalityId', placeholder: t('Vui lòng chọn...'), value: field.value, onChange: function (item) { return field.onChange(item.value); }, hasError: field.isError, onBlur: field.onBlur }),
                                React__default.createElement(Form.Error, null)));
                        })),
                    React__default.createElement(Row, { gutter: [24, 16] },
                        React__default.createElement(Form.Item, { name: 'genderId', rules: rules({ types: ['required'], t: t }) }, function (field) {
                            return (React__default.createElement(Col, { xs: 24, md: 12 },
                                React__default.createElement(Form.Label, null,
                                    " ",
                                    t('Giới tính')),
                                React__default.createElement(Contact.RadioGroup, null,
                                    React__default.createElement(SingleRadio, { id: 'gender-male', label: t('Nam'), onChange: function (value) {
                                            field.onChange(1);
                                        }, name: '', isLeftRadio: true, checked: field.value === 1, width: 'fit-content' }),
                                    React__default.createElement(SingleRadio, { id: 'gender-female', label: t('Nữ'), onChange: function (value) { return field.onChange(2); }, name: 'gender', isLeftRadio: true, checked: field.value === 2, width: 'fit-content' })),
                                React__default.createElement(Form.Error, null)));
                        }),
                        React__default.createElement(Form.Item, { name: 'maritalStatusId', rules: rules({ types: ['required'], t: t }) }, function (field) {
                            return (React__default.createElement(Col, { xs: 24, md: 12 },
                                React__default.createElement(Form.Label, null,
                                    " ",
                                    t('Tình trạng hôn nhân')),
                                React__default.createElement(Contact.RadioGroup, null,
                                    React__default.createElement(SingleRadio, { id: 'marital-status-single', label: t('Độc thân'), onChange: function () { return field.onChange(EMaritalStatus.SINGLE); }, name: 'marital-status', isLeftRadio: true, checked: field.value === EMaritalStatus.SINGLE, width: 'fit-content' }),
                                    React__default.createElement(SingleRadio, { id: 'marital-status-married', label: t('Đã kết hôn'), onChange: function () { return field.onChange(EMaritalStatus.MARRIED); }, name: 'marital-status', isLeftRadio: true, checked: field.value === EMaritalStatus.MARRIED, width: 'fit-content' })),
                                React__default.createElement(Form.Error, null)));
                        })),
                    React__default.createElement(Row, { gutter: [24, 16] },
                        React__default.createElement(Form.Item, { name: 'countryId', rules: rules({ types: ['required'], t: t }) }, function (field) {
                            return (React__default.createElement(Col, { xs: 24, md: 12 },
                                React__default.createElement(Form.Label, null,
                                    " ",
                                    t('Quốc gia')),
                                React__default.createElement(MultipleRadio, { options: countryOptions !== null && countryOptions !== void 0 ? countryOptions : [], name: 'countryId', placeholder: t('Vui lòng chọn...'), value: field.value, onChange: function (item) {
                                        field.onChange(item.value);
                                        if (item.value !== VIETNAM_COUNTRY_ID) {
                                            field.setFieldValue('cityId', INTERNATIONAL_CITY_ID);
                                            return;
                                        }
                                        field.setFieldValue('cityId', undefined);
                                    }, onBlur: field.onBlur, hasError: field.isError, dropdown: {
                                        maxHeight: '250px',
                                        isSearchable: true,
                                        emptyText: t('Không Có Kết Quả Nào'),
                                        searchBoxPlaceholder: t('Tìm'),
                                        floatingConfig: {
                                            position: 'fixed',
                                            enablePortal: true,
                                            useWindowAsFlippingContainer: true
                                        }
                                    } }),
                                React__default.createElement(Form.Error, null)));
                        }),
                        React__default.createElement(Form.Item, { name: 'cityId', watch: ['countryId'], rules: [
                                {
                                    type: 'custom',
                                    validator: function (value, watch) {
                                        if (!value && (watch === null || watch === void 0 ? void 0 : watch.countryId) === VIETNAM_COUNTRY_ID) {
                                            return false;
                                        }
                                        return true;
                                    },
                                    msg: t('Vui lòng nhập thông tin.')
                                }
                            ] }, function (field) {
                            var _a, _b, _c;
                            return (React__default.createElement(Col, { xs: 24, md: 12 },
                                React__default.createElement(Form.Label, { require: ((_a = field.watch) === null || _a === void 0 ? void 0 : _a.countryId) === VIETNAM_COUNTRY_ID }, t('Tỉnh/Thành phố')),
                                React__default.createElement(MultipleRadio, { options: cityOptions !== null && cityOptions !== void 0 ? cityOptions : [], name: 'cityId', placeholder: t('Vui lòng chọn...'), value: field.value, onChange: function (item) {
                                        field.setFieldValue('districtId', undefined);
                                        field.onChange(item.value);
                                    }, onBlur: field.onBlur, disable: !(((_b = field === null || field === void 0 ? void 0 : field.watch) === null || _b === void 0 ? void 0 : _b.countryId) === VIETNAM_COUNTRY_ID), hasError: field.isError, dropdown: {
                                        maxHeight: '250px',
                                        isSearchable: true,
                                        emptyText: t('Không Có Kết Quả Nào'),
                                        searchBoxPlaceholder: t('Tìm'),
                                        floatingConfig: {
                                            position: 'fixed',
                                            enablePortal: true,
                                            useWindowAsFlippingContainer: true
                                        }
                                    } }),
                                React__default.createElement(Form.Error, { disable: !(((_c = field === null || field === void 0 ? void 0 : field.watch) === null || _c === void 0 ? void 0 : _c.countryId) === VIETNAM_COUNTRY_ID) })));
                        })),
                    React__default.createElement(Row, { gutter: [24, 16] },
                        React__default.createElement(Form.Item, { name: 'districtId', watch: ['countryId', 'cityId'], rules: [
                                {
                                    type: 'custom',
                                    validator: function (value, watch) {
                                        var isCheckCityId = notAllowCityId.includes(watch === null || watch === void 0 ? void 0 : watch.cityId);
                                        if (watch.countryId !== VIETNAM_COUNTRY_ID || isCheckCityId) {
                                            return true;
                                        }
                                        if (!value && !isCheckCityId && watch.countryId === VIETNAM_COUNTRY_ID) {
                                            return false;
                                        }
                                        return true;
                                    },
                                    msg: t('Vui lòng nhập thông tin.')
                                }
                            ] }, function (field) {
                            var _a, _b, _c, _d, _e, _f, _g, _h;
                            return (React__default.createElement(Col, { xs: 24, md: 12 },
                                React__default.createElement(Form.Label, { require: ((_a = field.watch) === null || _a === void 0 ? void 0 : _a.countryId) === VIETNAM_COUNTRY_ID &&
                                        !notAllowCityId.includes((_b = field.watch) === null || _b === void 0 ? void 0 : _b.cityId) }, t('Quận/Huyện')),
                                React__default.createElement(MultipleRadio, { options: ((_c = field.watch) === null || _c === void 0 ? void 0 : _c.cityId) && districtOptions
                                        ? getLocalizedOptions(districtOptions["".concat(Number((_d = field.watch) === null || _d === void 0 ? void 0 : _d.cityId))])
                                        : [], name: 'District', placeholder: t('Vui lòng chọn...'), value: field.value, onChange: function (item) { return field.onChange(item.value); }, onBlur: field.onBlur, hasError: field.isError, dropdown: {
                                        maxHeight: '250px',
                                        isSearchable: true,
                                        emptyText: t('Không Có Kết Quả Nào'),
                                        searchBoxPlaceholder: t('Tìm'),
                                        floatingConfig: {
                                            position: 'fixed',
                                            enablePortal: true,
                                            useWindowAsFlippingContainer: true
                                        }
                                    }, disable: !(((_e = field.watch) === null || _e === void 0 ? void 0 : _e.countryId) === VIETNAM_COUNTRY_ID) ||
                                        notAllowCityId.includes((_f = field.watch) === null || _f === void 0 ? void 0 : _f.cityId) }),
                                React__default.createElement(Form.Error, { disable: !(((_g = field.watch) === null || _g === void 0 ? void 0 : _g.countryId) === VIETNAM_COUNTRY_ID) ||
                                        notAllowCityId.includes((_h = field.watch) === null || _h === void 0 ? void 0 : _h.cityId) })));
                        }),
                        React__default.createElement(Form.Item, { name: 'address' }, function (field) {
                            return (React__default.createElement(Col, { xs: 24, md: 12 },
                                React__default.createElement(Form.Label, null,
                                    " ",
                                    t('Địa chỉ')),
                                React__default.createElement(Input, { type: 'text', value: field.value, onChange: field.onChange, onBlur: field.onBlur, hasError: field.isError }),
                                React__default.createElement(Form.Error, null)));
                        })),
                    React__default.createElement(Row, null,
                        React__default.createElement(Col, null,
                            React__default.createElement(Required, null,
                                React__default.createElement("span", null, "*"),
                                " ",
                                t('Thông tin bắt buộc')))))))));
};
var ContactInfo$1 = React__default.forwardRef(ContactInfo);

export { ContactInfo$1 as default };
//# sourceMappingURL=ContactInfo.js.map
